import authorityActions from '@authority/authority-shared/utilities/redux/actions';

export const actions = {

  ...authorityActions
};